import { useRequest } from '@10000/react'
import { Body, Box, H3 } from '../widgets'
import { InputScreen, useBackground, useShell } from '../layout'
import { Submit, Text } from '../forms'

export const Register = ({ active }) => {
  const request = useRequest('squiz')

  useShell({ active, mode: 'logo' })
  useBackground().set({ active, background: 1, fade: true, size: '500%', position: 'center -300px' })

  const register = fields => request('registrationSubmitted', fields)

  return (
    <InputScreen gap={24} onSubmit={register}>
      <H3>Thank you for playing!</H3>

      <Body lineHeight="24px" align="center">
        Ready to see your personalized results?
        Join our launch waiting list now and receive 50% off your first year!
        Complete the form below to get started.
      </Body>

      <Box column fullWidth gap={16}>
        <Text name="firstname" title="First name" required />
        <Text name="lastname" title="Last name" required />
        <Text name="email" title="Email" type="email" required />
      </Box>

      <Submit fullWidth>Submit</Submit>
    </InputScreen>
  )
}